import React from 'react';

/**
 * A phone screenshot. `framed={false}` is for the KMO crops (they already contain a phone frame and
 * transparent corners); `framed` wraps a raw screen in a generic CSS frame — no Apple bezels,
 * notches or brand shapes. The <img> always carries width/height so nothing shifts on load.
 */
const MkPhone = ({
  src,
  srcSet,
  sizes,
  width,
  height,
  alt,
  framed = false,
  fade = false,
  eager = false,
  priority = false,
  className,
  ...rest
}) => {
  const classes = ['mk-phone', framed ? 'mk-phone--framed' : 'mk-phone--bare', fade && 'mk-phone--fade', className]
    .filter(Boolean)
    .join(' ');
  const priorityAttr = priority ? { fetchpriority: 'high' } : {};
  return (
    <div {...rest} className={classes}>
      <img
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        width={width}
        height={height}
        alt={alt}
        decoding="async"
        loading={eager ? 'eager' : 'lazy'}
        {...priorityAttr}
      />
    </div>
  );
};

export default MkPhone;
